// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-dropdown {
    border: 1px solid whitesmoke;
    height: 1.5em;
}

:host ::ng-deep .p-dropdown {
    border-color: whitesmoke;
}

:host ::ng-deep .p-dropdown:hover,
:focus {
    border-color: whitesmoke;
}

:host ::ng-deep .p-dropdown .p-dropdown-trigger {
    background-color: rgb(33, 37, 41);
    width: 1.5em;
}

:host ::ng-deep .p-dropdown-items-wrapper {
    border-radius: 3px;
}

:host ::ng-deep .p-dropdown .p-dropdown-label {
    width: 13em;
    text-align: center;
    padding: 0;
    background: rgb(33, 37, 41);
    font-size: 12px;
    margin-right: 0.5px;
    font-family: "EYInterstate-light";
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items {
    padding: 0;
    border: thin black;
    background: rgb(33, 37, 41);
    color: #fff;
    width: 9.8em;
}

.display-flex {
    display: flex;
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    line-height: 0.8em;
    font-size: 12px;
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #212529;
    background-color: #ffe082 !important;
}

.lang-disabled {
    color: lightgray;
    cursor: not-allowed;
    opacity: 0.5;
}
.spacing {
  padding-right: 0.7rem !important;
}

:host ::ng-deep .p-menu > ul {
    padding: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
